import type {ReactAction} from '@netx/core/bootstrap';
import {faClipboardList} from '@netx/core-icons';
import {type IAsset} from '@netx/core-asset-next/schema';
import {canCreateAssetProject} from '../enablers';
import {ASSET_PROJECT_ACTION_LABELS} from '../locales';
import {ASSET_PROJECT_EVENT} from './constants';

export const assetProjectActionAddIcon = faClipboardList;

/**
 * Add asset to project
 * @param params
 * @returns Action
 */
export const assetProjectActionAdd = (
	asset: IAsset,
	params: Partial<ReactAction> = {},
): ReactAction => ({
	name: 'asset-project-create-from-asset',
	cb: () => dispatcher.trigger(ASSET_PROJECT_EVENT.PROJECT, asset),
	enableTest: () => canCreateAssetProject(asset),
	icon: assetProjectActionAddIcon,
	get label() {
		return ASSET_PROJECT_ACTION_LABELS.PROJECT;
	},
	...params,
});

export default assetProjectActionAdd;
